<template>
    <div class="contract-pdf">
        <div class="header">
            <div class="wrap">
                <img class="logo" src="https://flypig-public.s3-ap-southeast-1.amazonaws.com/images/email/flypig.png" alt="">
                <div class="title">
                    房屋租賃電子合約書
                </div>
                <div class="btn-group">
                    <button v-if="this.$route.query.type==='release'" class="default-button" @click="releaseContract()">確認退租</button>
                </div>
            </div>
        </div>
        <pdf
            v-for="i in numPages"
            :key="i"
            :src="pdf"
            :page="i"
        ></pdf>
    </div>
</template>
<script>
// import VuePdfApp from "vue-pdf-app";
// import this to use default icons for buttons
// import "vue-pdf-app/dist/icons/main.css";
import pdf from 'vue-pdf'
import { 
    apiContractThrowLease,
    apiGetContractPDF
    } from "@/apis/api.js"; 
export default {
    data () {
        return {
            pdf: null,
            numPages: undefined,
            config: {
                toolbar: false
            },
        }
    },
    mounted () {
        // console.log(this.$route.query.cid)
        // this.$analytics.logEvent('查看合約', { screen_name: '查看合約'})
        if(this.$route.query.cid){
            this.getContractPDF(this.$route.query.cid)
            // this.getContractPapet(this.$route.query.cid)
        }
    },
    methods: {
        getContractPDF: function (cid) {
            console.log(cid)
            apiGetContractPDF(cid)
            .then( res => {
                
                if(res.status == 200){
                    this.pdf = pdf.createLoadingTask(new Uint8Array(res.data))
                    this.pdf.promise.then(pdf => {
                        this.numPages = pdf.numPages;
                    });
                //    window.open(res.data);
                    // var blob = new Blob([res.data], { type: 'application/pdf' });
                    // const url = window.URL.createObjectURL(new Blob([res.data], { type: 'application/pdf;charset-UTF-8' }));
                    // window.open(url);
                }
            })
            .catch( err => {
                console.log(err)
            })
        },
        releaseContract: function () {
            let data = this.$route.query.cid
            apiContractThrowLease(data)
            .then(res => {
                if(res.data.status = "SUCCESS"){
                    this.$router.push({name: 'leasemanagementdefault'})
                    this.$store.dispatch('setAlarmStatus', {status: true,title: '已通知房客進行退租',type: 'success'})
                }else{
                    this.$store.dispatch('setAlarmStatus', {status: true,title: res.data.errorMsg, type: 'error'})
                }
            })
            .catch(err => {
                this.$store.dispatch('setAlarmStatus', {status: true,title: err, type: 'error'})
            })
        },
    },
    components: {
        pdf
    }
}
</script>
<style lang="scss" scoped>
.contract-pdf{
    .header{
        position: fixed;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 89px;
        -webkit-backdrop-filter: blur(10px);
        backdrop-filter: blur(10px);
        background-color: #ffffff;
        top: 0px;
        left: 0;
        z-index: 6;
        .wrap  {
            position: relative;
            display: flex;
            align-items: center;
            justify-content: center;
            width: 100%;
            max-width: 1440px;
            >.title{
                font-size: 28px;
                font-weight: 500;
                color: #ff9275;
            }
            .logo{
                position: absolute;
                left: 90px;
                width: 60px;
                height: 60px;
                margin-bottom: 0px;
            }
            .btn-group{
                position: absolute;
                display: flex;
                align-items: center;
                z-index: 2;
                right: 90px;
                .default-button{
                    position: relative;
                    width: 120px;
                }
            }
        }
    }
    #vuePdfApp{
        margin-top: 90px;
        height: 1000px;
        z-index: 4;
    }
}
@media (max-width: 960px) {
    .contract-pdf{
        .header{
            height: 49px;
            .wrap{
                >.title{
                    font-size: 16px;
                }
                .logo{
                    left: 15px;
                    width: 40px;
                    height: 40px;
                }
                .btn-group{
                    .default-button{
                        position: relative;
                        width: 100px;
                        height: 33px;
                    }
                }
            }
        }
    }
}
@media (max-width: 540px) {
    .contract-pdf{
        .header{
            .wrap{
                .logo{
                    left: 13px;
                }
                .btn-group{
                    right: 13px;
                }
            }
        } 
        
    }
}
</style>


// WEBPACK FOOTER //
// src/pages/landlord/LeaseManagementPages/contractPdf.vue